import React from "react";
import { Box, Container } from "@mui/system";
import { Grid } from "@mui/material";

export default function Layout1Section3({ acf }) {
  return (
    <Box
      sx={{
        position: "relative",
        mt: "-8rem",
        mb: "2rem",
      }}
    >
      <Container
        maxWidth="xl"
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          color: "#fff",
          transform: "translateZ(1px)",
        }}
      >
        <Box
          sx={{
            width: {
              xs: "100%",
            },
          }}
        >
          {acf?.featured_images && acf?.featured_images.length > 0 ? (
            <Grid
              container
              spacing={4}
              sx={{
                width: "100%",
                marginTop: "20px",
              }}
            >
              {acf.featured_images.map((featured_image, index) => (
                <Grid
                  item
                  xs={12}
                  md={6}
                  key={index}
                  sx={{
                    marginBottom: "20px",
                    display: "flex",
                  }}
                >
                  <img
                    src={featured_image.featured_image.url}
                    alt={featured_image.featured_image.alt}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </Grid>
              ))}
            </Grid>
          ) : null}
        </Box>
      </Container>
    </Box>
  );
}
